import {
    BREAK_POINT_SCREEN_SM,
    BREAK_POINT_SCREEN_XS,
    BREAK_POINT_SCREEN_MD,
    BREAK_POINT_SCREEN_LG,
} from '@client/config/constants';

export const isXsScreen = w => w && (w < BREAK_POINT_SCREEN_XS);
export const isSmScreen = w => w && (w < BREAK_POINT_SCREEN_SM);
export const isMdScreen = w => w && (w < BREAK_POINT_SCREEN_MD);
export const isLgScreen = w => w && (w < BREAK_POINT_SCREEN_LG);
export const isXlScreen = w => w && (w >= BREAK_POINT_SCREEN_LG);
